import React, { useEffect, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import useForm from '../../shared/useFormHook';
import Input from '../../shared/input/Input';
import { Button, Icon } from 'antd';
import UploadAvatar from '../../../../components/Common/UploadAvatar';
import TuringHelpBtn from '../../shared/TuringHelpBtn/TuringHelpBtn';
import useFlagsFromBackend, { GB_FLAGS } from '../../../services/launchDarkly';
import { validateGithubUrl, validateLinkedInUrl } from '../../../util/inputValidators';

function PersonalInformationForm ({ service, customClass }) {
  const name = 'PersonalInformation';
  const linkedErrorMessage = 'Invalid url format. Acceptable format (https://www.linkedin.com/in/username/)';
  const githubErrorMessage = 'Invalid url format. Acceptable format (https://www.github.com/username/)';
  const { addSugg, onSaveClick, removeEvent, onPanelSelect, handleUpdateAvatar, handleUpdatePersonalInformation, save, setCompleted } = service;
  const { PersonalInformation } = service.state;
  const { isReadOnly } = service.props;
  const { urlError } = service.props && service.props.store && service.props.store.resumeUpload && service.props.store.resumeUpload;
  const { data, bind, setData, getData, getErrors, getChanges, resetError } = useForm({}, service.saveDebounce);
  const [ validationError, setValidationError ] = useState({})
  const { $flagsReady, enable_linkedin_sync } = useFlagsFromBackend([GB_FLAGS.enable_linkedin_sync]);

  useEffect(() => {
    setData(PersonalInformation);
  }, [PersonalInformation]);

  const onSave = useCallback(async (isAutoSave) => {
    if (!isAutoSave) {resetError(); setValidationError({})};
    const fields = ['github_url', 'linkedin_url', 'summary'];
    const changedFields = await getChanges(PersonalInformation, fields);
    if (!changedFields.length) return true;
    const values = await getData();
    const errors = await getErrors();
    setValidationError({
      githubError: !validateGithubUrl(values.github_url || ''),
      linkedInError: !validateLinkedInUrl(values.linkedin_url || ''),
      // summaryError: !validateStringOnly(values.summary || '')
    });
    const inputValError = !validateGithubUrl(values.github_url || '') || !validateLinkedInUrl(values.linkedin_url || '') /*|| !validateStringOnly(values.summary || '')*/;
    if (errors.length || inputValError) {
      if (!isAutoSave) {
        onPanelSelect('PersonalInformation');
        setCompleted('PersonalInformation', false);
      }
      return false;
    }
    values.github_url = values.github_url || '';
    values.linkedin_url = values.linkedin_url || '';
    values.summary = values.summary || '';
    const success = await handleUpdatePersonalInformation(values, isAutoSave);
    if (success && isAutoSave) {
      service.setState({ PersonalInformation: { ...PersonalInformation, ...values } });
    }
    if (!success && !isAutoSave) {
      onPanelSelect('PersonalInformation');
      setCompleted('PersonalInformation', false);
    }
    return success ? 'PersonalInformation' : false;
  }, [PersonalInformation]);

  useEffect(() => {
    addSugg(name, { id: 'addaccounts1', content: <p>Adding Github and LinkedIn profiles will help recruiters learn more about you and your interests.</p> });
    addSugg(name, { id: 'addaccounts2', content: <p>Give examples while while telling us about yourself.</p> });
    addSugg(name, { id: 'addaccounts3', content: <p>Photos dimension, size.</p> });
    addSugg(name, { id: 'addaccounts4', content: <p>Reference image.</p> });
    onSaveClick('PersonalInformation', onSave);
    return () => removeEvent('PersonalInformation');
  }, [onSave]);

  return (
    <div className={customClass || ''}>
      <div className={`PersonalInformationForm ${enable_linkedin_sync ? 'new': ''}`}>
        {!$flagsReady || !enable_linkedin_sync ?
        (<>
          <div className="a"><p>Let’s start and get to know you better!!! 😃</p></div>
          <div className="b">
            <UploadAvatar key={data.avatar} avatarUrl={data.avatar} onUpdateAvatar={handleUpdateAvatar} inline enable_linkedin_sync={enable_linkedin_sync}/>
          </div>
          <div className="c"><Input label="Github" placeholder="github.com/" {...bind('github_url')}/>{validationError.githubError ? <div className='profile-error'>{githubErrorMessage}</div> : null}</div>
          <div className="d"><Input label="LinkedIn" placeholder="linkedin.com/in/" {...bind('linkedin_url')} />{validationError.linkedInError ? <div className='profile-error'>{linkedErrorMessage}</div> : null}</div>
          <div className="e">
            <Input.TextArea className="summary" label={<TuringHelpBtn
            help={
              <ul style={{ padding: 0, paddingLeft: 20 }}>
                <li>Identify yourself professionally</li>
                <li>Describe the tech skills and soft skills you want to highlight</li>
                <li>Mention your personal strengths with supporting examples</li>
                <li>Outline your career goals</li>
              </ul>
            }
          >Tell us about your skills, strengths, work style, and personality.</TuringHelpBtn>} placeholder={'- Identify yourself professionally\n- Describe the tech skills and soft skills you want to highlight\n- Mention your personal strengths with supporting examples\n- Outline your career goals'} {...bind('summary')} /></div>
          {/* {validationError.summaryError ? <div className='profile-error'>{errorMessage}</div> : null} */}
        </>)
        :
        (<>
          <div className="a">
            <UploadAvatar key={data.avatar} avatarUrl={data.avatar} onUpdateAvatar={handleUpdateAvatar} inline />
          </div>
          <p className='b'>
          You can provide your LinkedIn Profile link down below, we will import your information from there and add it to your Profile.
          </p>
          <div className="c linkedin-input-cont">
            <span className="linkedin-wrapper">
              <Input prefix={<Icon type="linkedin" theme="filled" height="1.5em" style={{color: "#2867B2", borderColor: urlError ? "red !important" : "#CCCCCC !important"}}/>}
                placeholder="https://www.linkedin.com/in/username/" {...bind('linkedin_url')} />
              {/* Hiding button until requirements clarified */}
              {/* <button
                style={{width: "200px"}}
                type="button"
                className="ant-btn-link"
              >
                <Button className='import-linkedin-profile-btn' onClick={() => 
                importLinkedData()
                }>Import LinkedIn Profile</Button>
              </button> */}
            </span>
            {urlError ? <label style={{color:"red"}}>{urlError}</label> : null}
            {validationError.linkedInError ? <label className='profile-error'>{linkedErrorMessage}</label> : null}
          </div>
          <div className="d linkedin-input-cont">
            <span className="linkedin-wrapper">
              <Input label="Github Profile" prefix={<Icon type="github" theme="filled" height="1.5em" />} {...bind('github_url')} />
            </span>
            {validationError.githubError ? <label className='profile-error'>{githubErrorMessage}</label> : null}
          </div>
          <div className="e"><Input.TextArea className="summary" 
              label="Tell us about your skills, strengths, work style, and personality" 
              placeholder={'- Identify yourself professionally\n- Describe the tech skills and soft skills you want to highlight\n- Mention your personal strengths with supporting examples\n- Outline your career goals'} {...bind('summary')} />
              {/* {validationError.summaryError ? <label className='profile-error'>{errorMessage}</label> : null} */}
          </div>
        </>)
        }
      </div>
      {isReadOnly ? null : (
        <div className="FinalizeResumeV2FormBtns">
          <Button onClick={() => onPanelSelect(null)}>Cancel</Button>
          <Button type="primary" onClick={() => save('PersonalInformation')}>Update information</Button>
        </div>
      )}
    </div>
  );
}

PersonalInformationForm.propTypes = {
  service: PropTypes.any,
  customClass: PropTypes.string
};

export default PersonalInformationForm;
